// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import app from './App.vue'

import home from './pages/Home.vue'
import road from './pages/Road.vue'
import online from './pages/Online.vue'
import teacher from './pages/Teacher.vue'
import blessing from './pages/Blessing.vue'
import card from './pages/Card.vue'
import result from './pages/Result.vue'
import share from './pages/Share.vue'
import resultShare from './pages/resultShare.vue'

Vue.use(VueRouter);

let App = Vue.extend(app)
let router = new VueRouter()

router.map({
    "/index": {
        name: "index",
        component: home
    },
    "/road": {
        name: "road",
        component: road
    },
    "/online": {
        name: "online",
        component: online
    },
    "/teacher": {
        name: "teacher",
        component: teacher
    },
    "/blessing": {
        name: "blessing",
        component: blessing
    },
    "/card": {
        name: "card",
        component: card
    },
    "/result": {
        name: "result",
        component: result
    },
    "/share": {
        name: "share",
        component: share
    },
    "/resultShare":{
      name: "resultShare",
      component: resultShare
    }
})

router.redirect({
    "*": "/index"
})

router.start(App, "#app")



// WEBPACK FOOTER //
// ./src/main.js